import React, { useEffect } from 'react';

/**
 * auth.ilouli.com으로 리다이렉트하는 컴포넌트
 * 모든 서브도메인 라우터에서 /login, /signup, /profile 경로에 사용
 */

// auth.ilouli.com URL 가져오기
const getAuthUrl = () => {
  const isLocal = window.location.hostname === 'localhost';
  return isLocal ? 'http://localhost:3001' : 'https://auth.ilouli.com';
};

const AuthRedirect = ({ path = '/login' }) => {
  useEffect(() => {
    const authUrl = getAuthUrl();
    const returnUrl = encodeURIComponent(window.location.href);
    window.location.href = `${authUrl}${path}?returnUrl=${returnUrl}`;
  }, [path]);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      color: '#666',
      backgroundColor: '#f5f5f7'
    }}>
      리다이렉트 중...
    </div>
  );
};

export default AuthRedirect;
